// extracted by mini-css-extract-plugin
export var footer = "_m4-5";
export var fulfillmentInput = "_m4-0";
export var shipDateInput = "_m4-1";
export var shipmentModal = "_m4-2";
export var shipmentModalContent = "_m4-3";
export var tableContainer = "_m4-4";